export default __webpack_public_path__ + "static/media/buddhahead.cddd8bd0.jpg";